<template>
  <div class="main">

    <el-tabs v-model="activeName" type="border-card" style="width: 100%;">
      <el-tab-pane label="设备列表" name="first">
        <!-- Right -->
        <div class="main_r">
          <!-- search -->
          <div class="search">
            <div>
              <el-input v-model="queryData.deviceName"  placeholder="请输入设备名称"></el-input>
              <el-input v-model="queryData.deviceSn"  placeholder="请输入设备唯一编号"></el-input>
              <el-select v-model="queryData.deviceStatus" placeholder="设备状态">
                <el-option label="请选择设备状态" value="0"></el-option>
                <el-option label="正常" value="1"></el-option>
                <el-option label="锁机" value="2"></el-option>
              </el-select>
              <el-date-picker v-model="queryData.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="起始时间" class="mr15"></el-date-picker>
              <el-date-picker v-model="queryData.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
              <el-button type="primary" @click="clickQuery">查询</el-button>
              <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
              <el-button type="primary" @click="clickdialogAdd">新增</el-button>
              <UploadExcel @change="changeUploadExcel"></UploadExcel>
            </div>
          </div>
          <!-- search End -->

          <!-- 列表 -->
          <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="id" label="序号" min-width="5%"></el-table-column>
            <el-table-column prop="deviceName" label="设备名称" min-width="15%"></el-table-column>
            <el-table-column prop="deviceSn" label="识别码" min-width="15%"></el-table-column>
            <el-table-column prop="deviceStatus" label="设备状态" min-width="5%">
              <template slot-scope="props">
                <span v-if="props.row.deviceStatus == 1">正常</span>
                <span v-if="props.row.deviceStatus == 2">锁机</span>
              </template>
            </el-table-column>
            <el-table-column prop="salesChannels" label="销售渠道" min-width="5%"></el-table-column>
            <el-table-column prop="salesAddress" label="销售地址" min-width="5%"></el-table-column>
            <el-table-column prop="firmWare" label="固件版本" min-width="5%"></el-table-column>
            <el-table-column prop="longitude" label="经度" min-width="5%"></el-table-column>
            <el-table-column prop="latitude" label="纬度" min-width="5%"></el-table-column>
            <el-table-column prop="altitude" label="海拔" min-width="5%"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="12%"></el-table-column>
            <el-table-column prop="Operation" label="操作" min-width="10%">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickdialogEdit(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-link :underline="false" type="danger" icon="el-icon-delete" class="mr12" @click="ClickDelete(scope.row)"></el-link>
                </el-tooltip>
<!--                <el-tooltip class="item" effect="dark" content="绑定蓝牙设备" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-attract" class="mr12" @click="gotoDeviceBindblesn(scope.row)"></el-link>
                </el-tooltip> -->
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="page_size"
              layout="prev, pager, next, sizes, jumper "
              :total="dataListnum">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>
        <!-- Right End -->

        <!---------------------- 以下是弹框内容 ---------------------->
        <!-- 新增 -->
        <el-dialog title="添加" :visible.sync="dialogAdd" width="26%" class="newAdd">
          <div class="addUser_body">
            <el-form ref="userMsg" :model="addData" label-width="120px">
              <el-form-item label="设备名称" :required=true>
                <el-input v-model="addData.deviceName" placeholder="请输入设备名称"></el-input>
              </el-form-item>
              <el-form-item label="设备唯一编号" :required=true>
                <el-input v-model="addData.deviceSn" placeholder="请输入设备唯一编号"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="DeviceInsert()" >确 认</el-button>
            <el-button @click="dialogAdd = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 新增 End -->

        <!-- 编辑信息 -->
        <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="26%" class="newAdd">
          <div class="addUser_body">
            <el-form ref="userMsg" :model="editData" label-width="120px">
              <el-form-item label="设备名称">
                <el-input v-model="editData.deviceName" placeholder="请输入设备名称"></el-input>
              </el-form-item>
              <el-form-item label="设备唯一编号">
                <el-input v-model="editData.deviceSn" placeholder="请输入设备唯一编号"></el-input>
              </el-form-item>
              <el-form-item label="设备状态">
                <el-select v-model="editData.deviceStatus" placeholder="设备状态">
                  <el-option label="请选择设备状态" value="0"></el-option>
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="锁机" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="销售渠道">
                <el-input v-model="editData.salesChannels" placeholder="请输入销售渠道"></el-input>
              </el-form-item>
              <el-form-item label="销售地址">
                <el-input v-model="editData.salesAddress" placeholder="请输入销售地址"></el-input>
              </el-form-item>
              <el-form-item label="固件版本号">
                <el-input v-model="editData.firmWare" placeholder="请输入固件版本号"></el-input>
              </el-form-item>
              <el-form-item label="经度">
                <el-input v-model="editData.longitude" placeholder="请输入经度"></el-input>
              </el-form-item>
              <el-form-item label="纬度">
                <el-input v-model="editData.latitude" placeholder="请输入纬度"></el-input>
              </el-form-item>
              <el-form-item label="海拔">
                <el-input v-model="editData.altitude" placeholder="请输入海拔"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="DeviceUpdate()" >确 认</el-button>
            <el-button @click="dialogEdit = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 编辑信息 End -->

        <!-- 删除 -->
        <el-dialog title="操作确认" :visible.sync="dialogDel" width="20%" class="confirmDel">
          <div class="confirmMsg">确定删除？</div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="DeviceDelete" >确 定</el-button>
            <el-button @click="dialogDel = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 删除 End -->
      </el-tab-pane>

      <!-- 绑定蓝牙设备 start -->
<!--      <el-tab-pane label="绑定蓝牙设备" name="second" disabled="disabled">
        <DeviceBindblesn ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></DeviceBindblesn>
      </el-tab-pane> -->
      <!-- 绑定蓝牙设备 end -->

    </el-tabs>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import DeviceBindblesn from '@/componentsSubVue/DeviceBindblesn.vue'
import UploadExcel from '../components/UploadExcel.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    DeviceBindblesn,
    UploadExcel
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        deviceName: '',
        deviceSn: '',
        deviceStatus: '0',
        timeBegin: '',
        timeEnd: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      // 新增
      dialogAdd: false,
      addData: {
        deviceName: '0',
        deviceSn: ''
      },
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        deviceName: '',
        deviceSn: '',
        deviceStatus: '',
        salesChannels: '',
        salesAddress: '',
        deviceType: '',
        firmWare: '',
        longitude: '',
        latitude: '',
        altitude: ''
      },
      // 删除
      deleteForm: {
        id: ''
      },
      dialogDel: false
    }
  },
  mounted () {
    this.DeviceList()
    this.DeviceNum()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    gotoDeviceBindblesn(row){
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    handleSizeChange (val) {
      this.page_size = val
      this.DeviceList()
      this.DeviceNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.DeviceList()
      this.DeviceNum()
    },
    clickQuery () {
      this.page_no = 1
      this.DeviceList()
      this.DeviceNum()
    },
    clickQueryReset () {
      this.queryData.deviceName = ''
      this.queryData.deviceSn = ''
      this.queryData.deviceStatus = '0'
      this.queryData.timeBegin = ''
      this.queryData.timeEnd = ''
      this.clickQuery()
    },
    clickdialogAdd () {
      this.dialogAdd = true
      this.addData.deviceName = ''
      this.addData.deviceSn = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.deviceName = row.deviceName
      this.editData.deviceSn = row.deviceSn
      this.editData.deviceStatus = row.deviceStatus.toString()
      this.editData.salesChannels = row.salesChannels
      this.editData.salesAddress = row.salesAddress
      this.editData.deviceType = row.deviceType
      this.editData.firmWare = row.firmWare
      this.editData.longitude = row.longitude
      this.editData.latitude = row.latitude
      this.editData.altitude = row.altitude
    },
    ClickDelete (row) {
      this.dialogDel = true
      this.deleteForm.id = row.id
    },
    changeUploadExcel (response) {
      console.log(response)
      Vue.prototype.FunRemindOnlyError(response)
      if (response.code === 1) {
        Vue.prototype.FunRemindAllways(response.data)
        this.DeviceList()
        this.DeviceNum()
      }
    },
    DeviceList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceName = that.queryData.deviceName
      data.deviceSn = that.queryData.deviceSn
      data.deviceStatus = that.queryData.deviceStatus
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    DeviceNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceName = that.queryData.deviceName
      data.deviceSn = that.queryData.deviceSn
      data.deviceStatus = that.queryData.deviceStatus
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    DeviceInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceName = that.addData.deviceName
      data.deviceSn = that.addData.deviceSn
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.DeviceList()
            that.DeviceNum()
            that.dialogAdd = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAdd = false
        })
    },
    DeviceUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.deviceName = that.editData.deviceName
      data.deviceSn = that.editData.deviceSn
      data.deviceStatus = that.editData.deviceStatus
      data.salesChannels = that.editData.salesChannels
      data.salesAddress = that.editData.salesAddress
      data.deviceType = that.editData.deviceType
      data.firmWare = that.editData.firmWare
      data.longitude = that.editData.longitude
      data.latitude = that.editData.latitude
      data.altitude = that.editData.altitude
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.DeviceList()
            that.DeviceNum()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    DeviceDelete: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.deleteForm.id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.DeviceList()
            that.DeviceNum()
          }
          that.dialogDel = false
        })
        .catch(function (error) {
          console.log(error)
          that.dialogDel = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 150px;
    margin-right: 15px;
  }

  .el-select{
    width: 150px;
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>

<style scoped>
::v-deep .el-tabs__content {
  padding: 5px;
}
</style>
